import SelectorEngine from '../../utils/dom/selector-engine';
import BaseComponent from '../BaseComponent';
import EventHandler from '../../utils/dom/event-handler';
import Manipulator from '../../utils/dom/manipulator';

const NAME = 'LoginPrompt';
class LoginPrompt extends BaseComponent {
	constructor(element) {
		super(element);
		this.init();
	}

	static get NAME() {
		return NAME;
	}

	init() {
		const element = this._element;
		const { id: elementId, timestamp } = Manipulator.getDataAttributes(element);
		
		if (elementId) {
			const previousTimestamp = +sessionStorage.getItem(elementId);

			if (timestamp - previousTimestamp > 0) {
				element.classList.remove('u-hidden');
			} else {
				element.remove();
			}

			const closeElement = SelectorEngine.findOne('.lta-login-prompt__close', element);

			EventHandler.on(closeElement, 'click', () => {
				sessionStorage.setItem(elementId, timestamp || 0);
				element.remove();
			});
		}

		if (!sessionStorage.getItem(elementId)) {
			element.classList.remove('u-hidden');
		}
	}
}

export default LoginPrompt;
